import { render, staticRenderFns } from "./WishlistBadgeCount.vue?vue&type=template&id=06bd4532&scoped=true"
import script from "./WishlistBadgeCount.vue?vue&type=script&lang=js"
export * from "./WishlistBadgeCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd4532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bd4532')) {
      api.createRecord('06bd4532', component.options)
    } else {
      api.reload('06bd4532', component.options)
    }
    module.hot.accept("./WishlistBadgeCount.vue?vue&type=template&id=06bd4532&scoped=true", function () {
      api.rerender('06bd4532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/WishlistBadgeCount.vue"
export default component.exports